module.exports = __webpack_public_path__ + "asset/image-Recurring-arrows-6e907e34cd1a9ca0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Recurring-arrows.svg
// module id = HLiI
// module chunks = 0